// removed by extract-text-webpack-plugin
module.exports = {"card":"kMxYuK4BwrdSzJISREH8_","card--rounded-4":"_1PUUTaWZGgGjdcuBzRZY-8","card__body":"_7j0saCQchk-UX3G7Aiw3T","card__title":"_1o2M2lV-OyCmUpZMWnlvJQ","card__tag":"_3D-W_cxA6TxELJaniywGvN","lecture-item":"_1na66mFMR_5OaW680WmUQn","image-container":"_3kfGWdykb68ZMXrZkmh65n"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Card/card.scss
// module id = 83
// module chunks = 0